import { gql } from '@apollo/client';

export const INSTALLATION_SETTINGS = gql`
  query InstallationSettings($id: UUID!) {
    userInstallation(where: { installationId: { eq: $id } }) {
      installationId
      name
      hexColor
      iconName
      isSelected
      accessType
      integrationType
      payload {
        ... on InstallationModelResponse {
          timeZone
          installationId
          coordinates {
            latitude
            longitude
          }
        }
      }
      externalPayload {
        ... on ExalusInstallationPayload {
          installationId
          pin
          serialNumber
        }
      }
    }
  }
`;

export const INSTALLATION_GET_ALL = gql`
  query InstallationGetAll {
    userInstallations(order: { order: ASC }) {
      items {
        installationId
        name
        hexColor
        iconName
        isSelected
        accessType
        order
        previewTariff
        integrationType
        externalPayload {
          ... on ExalusInstallationPayload {
            installationId
            pin
            serialNumber
          }
        }
      }
      cacheInfo {
        hash
      }
    }
  }
`;

export const CURRENT_INSTALLATION = gql`
  query CurrentInstallation {
    currentInstallation {
      installationId
      brokerUrl
      payload {
        ... on InstallationModelResponse {
          timeZone
          coordinates {
            latitude
            longitude
          }
        }
      }
      cacheResponses {
        measurementMapCache {
          hash
        }
        actionsCache {
          hash
        }
        groupsCache {
          hash
        }
        installationsCache {
          hash
        }
      }
    }
  }
`;
